import { useState, useEffect } from "react";
import API from "../Context/api";
import { useAuth } from "../Context/AuthContext";
import ErrorMessage from "../Helpers/ErrorMessage";

function AddLocalPurchaseOrderForm({ setIsModalOpen, onLpoUpdated }) {
  const [customer, setCustomer] = useState("");
  const [clientLocation, setClientLocation] = useState("");
  const [items, setItems] = useState([]);
  const [description, setDescription] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [uom, setUom] = useState(""); // New state for Unit of Measure
  const [subTotal, setSubTotal] = useState(0);
  const [vat, setVat] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useAuth();
  const createdBy = user ? user.name : "";

  useEffect(() => {
    const calculatedSubTotal = items.reduce(
      (sum, item) => sum + (item.totalPrice || item.quantity * item.unitPrice),
      0
    );
    setSubTotal(calculatedSubTotal);
    const calculatedVat = Math.round(calculatedSubTotal * 0.18);
    setVat(calculatedVat);
    setGrandTotal(calculatedSubTotal + calculatedVat);
  }, [items]);

  const addItem = () => {
    if (
      description.trim() !== "" &&
      quantity > 0 &&
      unitPrice > 0 &&
      uom.trim() !== ""
    ) {
      const totalPrice = parseFloat(quantity) * parseFloat(unitPrice);
      setItems([
        ...items,
        { description, quantity, unitPrice, uom, totalPrice },
      ]);
      setDescription("");
      setQuantity("");
      setUnitPrice("");
      setUom("");
    } else {
      alert(
        "Please fill in all item fields (Description, Quantity, Unit Price, U.O.M)."
      );
    }
  };

  const deleteItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const saveLpo = async () => {
    if (!customer.trim() || !clientLocation.trim() || items.length === 0) {
      alert(
        "Please add a customer name, client location, and at least one item."
      );
      return;
    }

    const lpoData = {
      customer: { client: customer },
      clientLocation,
      items,
      lpoHeader: {
        companyName: "KEVMARK INVESTMENTS LTD",
        companyTIN: "1000135996",
        address:
          "Plot 59 Nkrumah-Nasser Link Plaza Nsooba, P.O. Box 71341 Kampala",
        phone: "0752 / 0772-551",
        email: ["kevmark2000@gmail.com", "sales@kevmarkinvestments.com"],
        description:
          "Stationary, Scholastic Materials, Toners, Computers, Computer Hardware and Software Maintenance",
      },
      lpoDetails: {
        date: new Date().toISOString().slice(0, 10),
      },
      createdBy,
    };

    try {
      setIsLoading(true);
      await API.post("/localpurchaseorders", lpoData);
      setCustomer("");
      setClientLocation("");
      setItems([]);
      onLpoUpdated();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error saving LPO:", error);
      setErrorMessage(
        `Failed to save LPO: ${error.message || "Unknown error"}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
      <div className="p-4 w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col h-[90vh] sm:h-[80vh]">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
          Add New Local Purchase Order
        </h2>
        <ErrorMessage message={errorMessage} />

        <div className="flex-1 overflow-y-auto px-2 py-2 space-y-4">
          {/* Customer and Client Location */}
          <div className="grid grid-cols-1 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Customer Name
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter customer name"
                value={customer}
                onChange={(e) => setCustomer(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Client Location
              </label>
              <textarea
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
                placeholder="e.g., P.O. Box 345,
            Mulwana Road,
            Kampala Uganda"
                rows="5"
                value={clientLocation}
                onChange={(e) => setClientLocation(e.target.value)}
              />
            </div>
          </div>

          {/* Item Entry */}
          {/* <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">
              Add Items
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
              <textarea
                className="md:col-span-2 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
                placeholder="Item description"
                rows="2"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <input
                type="number"
                className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Qty"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />
              <input
                type="text"
                className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="U.O.M (e.g., pcs)"
                value={uom}
                onChange={(e) => setUom(e.target.value)}
              />
              <input
                type="number"
                className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Unit Price (USD)"
                value={unitPrice}
                onChange={(e) => setUnitPrice(e.target.value)}
              />
              <button
                onClick={addItem}
                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
              >
                Add Item
              </button>
            </div>
          </div> */}
          <div className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-4">
              Add New Item
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 items-start">
              <div className="md:col-span-2">
                <label
                  className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                  htmlFor="description"
                >
                  Item Description
                </label>
                <textarea
                  id="description"
                  className="w-full p-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 text-gray-700 dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500"
                  placeholder="Enter item description"
                  rows="2"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div>
                <label
                  className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                  htmlFor="quantity"
                >
                  Quantity
                </label>
                <input
                  id="quantity"
                  type="number"
                  className="w-full p-3 h-12 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 text-gray-700 dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500"
                  placeholder="Quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </div>
              <div>
                <label
                  className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                  htmlFor="uom"
                >
                  Unit of Measure
                </label>
                <input
                  id="uom"
                  type="text"
                  className="w-full p-3 h-12 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 text-gray-700 dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500"
                  placeholder="Unit of Measure (e.g., pcs)"
                  value={uom}
                  onChange={(e) => setUom(e.target.value)}
                />
              </div>
              <div>
                <label
                  className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                  htmlFor="unitPrice"
                >
                  Unit Price
                </label>
                <input
                  id="unitPrice"
                  type="number"
                  className="w-full p-3 h-12 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 text-gray-700 dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500"
                  placeholder="Unit Price (USD)"
                  value={unitPrice}
                  onChange={(e) => setUnitPrice(e.target.value)}
                />
              </div>
              <div className="flex items-end">
                <button
                  onClick={addItem}
                  className="w-full bg-indigo-600 text-white px-4 py-3 rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all duration-200 font-medium"
                >
                  Add Item
                </button>
              </div>
            </div>
          </div>

          {/* Items Table */}
          {/* <div className="flex-1 overflow-y-auto mb-6">
            <table className="w-full border-collapse border border-gray-200">
              <thead>
                <tr className="bg-gray-100 text-gray-700">
                  <th className="border p-3 text-left">Description</th>
                  <th className="border p-3 text-center">Qty</th>
                  <th className="border p-3 text-center">U.O.M</th>
                  <th className="border p-3 text-center">Unit Price (USD)</th>
                  <th className="border p-3 text-center">Total Price (USD)</th>
                  <th className="border p-3 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="border p-3">{item.description}</td>
                    <td className="border p-3 text-center">{item.quantity}</td>
                    <td className="border p-3 text-center">{item.uom}</td>
                    <td className="border p-3 text-center">{item.unitPrice}</td>
                    <td className="border p-3 text-center">
                      {item.totalPrice}
                    </td>
                    <td className="border p-3 text-center">
                      <button
                        onClick={() => deleteItem(index)}
                        className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 transition"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div> */}
          <div className="flex-1 overflow-y-auto mb-8">
            <table className="w-full border-collapse bg-white dark:bg-gray-800 rounded-lg shadow-sm">
              <thead>
                <tr className="bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100 text-sm font-medium">
                  <th className="p-4 text-left">Description</th>
                  <th className="p-4 text-center">Qty</th>
                  <th className="p-4 text-center">U.O.M</th>
                  <th className="p-4 text-center">Unit Price (USD)</th>
                  <th className="p-4 text-center">Total Price (USD)</th>
                  <th className="p-4 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr
                    key={index}
                    className="border-t border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-150"
                  >
                    <td className="p-4 text-gray-700 dark:text-gray-200">
                      {item.description}
                    </td>
                    <td className="p-4 text-center text-gray-700 dark:text-gray-200">
                      {item.quantity}
                    </td>
                    <td className="p-4 text-center text-gray-700 dark:text-gray-200">
                      {item.uom}
                    </td>
                    <td className="p-4 text-center text-gray-700 dark:text-gray-200">
                      {item.unitPrice}
                    </td>
                    <td className="p-4 text-center text-gray-700 dark:text-gray-200">
                      {item.totalPrice}
                    </td>
                    <td className="p-4 text-center">
                      <button
                        onClick={() => deleteItem(index)}
                        className="bg-red-600 text-white px-3 py-1.5 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all duration-200 text-sm font-medium"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Totals */}
          {/* <div className="mt-4 text-right text-lg font-semibold text-gray-800">
            <p>Sub Total: USD {subTotal.toLocaleString()}</p>
            <p>VAT 18%: USD {vat.toLocaleString()}</p>
            <p>Grand Total: USD {grandTotal.toLocaleString()}</p>
          </div> */}
          <div className="mt-4 text-right text-sm text-gray-700">
            <p className="mb-1">
              Sub Total:{" "}
              <span className="font-medium">
                USD {subTotal.toLocaleString()}
              </span>
            </p>
            <p className="mb-1">
              VAT 18%:{" "}
              <span className="font-medium">USD {vat.toLocaleString()}</span>
            </p>
            <p className="text-base font-semibold text-gray-800">
              Grand Total: USD {grandTotal.toLocaleString()}
            </p>
          </div>
        </div>
        {/* Buttons */}
        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={saveLpo}
            disabled={isLoading}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
              isLoading
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
          <button
            onClick={() => setIsModalOpen(false)}
            className="bg-gray-500 text-white px-6 py-2 rounded-md hover:bg-gray-600 transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddLocalPurchaseOrderForm;
